export default __webpack_public_path__ + "static/he-2454817b4456ed2172e474b723e31e02.png";